export enum AUTH_ROLES {
  USER = 'USER',
  ADMIN = 'ADMIN',
}
